module.exports = {"labels":{"name":"Nome","email":"E-mail","validateEmail":"Confirme o e-mail","site":"Site","telephone":"Telefone principal","line":"Ramal","telephoneType":"Tipo","cellphone":"Celular","promotions":"Quero saber das promoções e novidades mais legais :D"},"telephoneTypeOptions":[{"value":1,"label":"Comercial"},{"value":2,"label":"Residencial"}]}


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/EditAdminContactForm/data.json
// module id = 1755
// module chunks = 0